import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HelperService } from '../../../util/helper/helper.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { Auth0Service } from '../../../authentication/auth0/auth0.service';
import { CommunicationService } from '../../../services/communication/communication.service';
import { orderBy } from "lodash";

@Component({
  selector: 'app-message-container',
  templateUrl: './message-container.component.html',
  styleUrls: ['./message-container.component.scss']
})
export class MessageContainerComponent {
  allMessages = [];
  limit = 10;
  participants = [];
  sidePanelOpened = true;
  selectedParticipant: any = {};
  isLoadData = false;
  loggedInUser;
  fakePatients = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  communicationServiceListener;

  constructor(public dialogRef: MatDialogRef<MessageContainerComponent>,
    private helper: HelperService,
    private afs: AngularFirestore,
    private auth0: Auth0Service,
    private communicationService: CommunicationService) {
    this.loggedInUser = this.auth0.idTokenDetail;
    this.communicationServiceListener = this.communicationService.getDashCommunications.subscribe(communications => {
      this.allMessages = [...communications];
      this.loadPatientList();
    })
  }

  loadPatientList() {
    const messages = this.allMessages.splice(0, 10);
 
    const patientIds = [];
    messages.map(x => {
      const index = this.participants.findIndex(y => y.id === x.id)
      if (index === -1)
        patientIds.push(x.id)
    })

    if (patientIds.length) {
      const patientListListener = this.afs.collection("Patient", ref => ref
        .where("id", "in", patientIds))
        .valueChanges()
        .subscribe((patientData: any) => {
          patientListListener.unsubscribe();
          if (patientData.length) {
            patientIds.map(x => {
              const patient = patientData.find(y => x === y.id);
              if (patient){
                if(this.participants.findIndex(z=> z.id === patient.id) === -1)
                  this.participants.push(this.helper.formatPatientData(patient))
              }
            })
            this.addMessageCount(messages);
            this.orderPatients();
            if (!this.selectedParticipant.id && this.participants.length) {
              this.selectedParticipant = this.participants[0];
            }

            this.isLoadData = true;
          }
        })
    } else {
      this.addMessageCount(messages);
      this.orderPatients();
      this.isLoadData = true;
    }
  }

  orderPatients() {
    if (this.participants.length)
      this.participants = orderBy(this.participants, item => item.messages.length && item.messages[0].sent, 'desc');
  }

  addMessageCount(messages) {
    if (this.participants.length) {
      this.participants.map(x => {
        const index = messages.findIndex(y => y.id === x.id);
        if (index !== -1){
          x.messages = messages[index].data;
          x.messageCount = messages[index].data.length? messages[index].data.filter(y=> y.type !== 'removed').length : 0
        }
      })
    }
  }

  trackByMethod(index: number, el: any): number {
    return el.id;
  }

  ngOnDestroy(): void {
    this.communicationServiceListener.unsubscribe();
  }

  isOver(): boolean {
    return window.matchMedia(`(max-width: 960px)`).matches;
  }

  onSelect(participant): void {
    this.selectedParticipant = participant;
  }

  onClosePopup(): void {
    this.dialogRef.close();
  }

  onScroll() {
    this.loadPatientList();
  }
}
